module.exports = __webpack_public_path__ + "static/media/avi.ef6f1fa7.png";